import React from 'react'
import { cn } from '../lib/utils.js'

export function Container({ className, children }) {
  return <div className={cn('mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8', className)}>{children}</div>
}

export function SectionLabel({ children, className }) {
  return null
}

export function SectionHeading({ eyebrow, title, description, align = 'left' }) {
  if (!title && !description) return null
  return (
    <div className={cn('max-w-3xl space-y-3', align === 'center' && 'mx-auto text-center')}>
      {eyebrow ? <SectionLabel>{eyebrow}</SectionLabel> : null}
      {title ? <h2 className="font-serif text-3xl leading-tight text-forest-900 sm:text-4xl">{title}</h2> : null}
      {description ? (
        !title ? (
          <h2 className="font-serif text-3xl leading-tight text-forest-900 sm:text-4xl">{description}</h2>
        ) : null
      ) : null}
    </div>
  )
}

export function Card({ className, children }) {
  return (
    <div
      className={cn(
        className,
      )}
    >
      {children}
    </div>
  )
}

export function ButtonLink({ children, href, variant = 'primary', className, onClick, ...props }) {
  const base =
    'inline-flex items-center justify-center gap-2 rounded-none px-5 py-3 text-sm font-semibold transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forest-700 focus-visible:ring-offset-2 focus-visible:ring-offset-sand-50'
  const variants = {
    primary: 'bg-forest-900 text-sand-50 hover:bg-forest-800',
    secondary: 'border border-forest-200 bg-white text-forest-900 hover:border-forest-300 hover:bg-sand-100',
    ghost: 'text-forest-900 hover:bg-sand-100',
  }

  if (href) {
    return (
      <a href={href} className={cn(base, variants[variant], className)} onClick={onClick} {...props}>
        {children}
      </a>
    )
  }

  return (
    <button type="button" className={cn(base, variants[variant], className)} onClick={onClick} {...props}>
      {children}
    </button>
  )
}

export function Pill({ children, className }) {
  return <span className={cn('inline-flex items-center rounded-full border border-forest-200 bg-white px-3 py-1 text-xs font-semibold text-forest-800', className)}>{children}</span>
}
